export default __webpack_public_path__ + "static/media/house9871923.f5913945.jpg";